// Vendor
import $ from 'jquery';
import Helpers from 'helpers/util';

let $el = $('.js-lightbox-share');

class Share {
	constructor($el) {
		this.$form = $el;
		Helpers.pubsub.subscribe('onLightboxShow', (name, e) => {
			if (e.hasClass('icon-share-forward')) {
				this.$button = e;
				this.updateFormId();
			}
		});
	}

	updateFormId() {
		if (this.$form.length) {
			this.$form.find('#article-id').val(this.$button.attr('data-id'));
		}
	}
}

const _init = () => {
	new Share($el);
};

_init();